console.log('[newsletter-form] script loaded');

document.addEventListener('submit', async (event) => {
  console.log('[newsletter-form] submit event fired', event.target);

  const form = event.target.closest('#NewsletterForm');
  if (!form) {
    console.log('[newsletter-form] event target is not #NewsletterForm, ignoring', event.target.id);
    return;
  }

  event.preventDefault();
  console.log('[newsletter-form] preventDefault called, form action:', form.action);

  const wrap = form.closest('[data-newsletter-form-wrap]');
  const submitButton = form.querySelector('button[type="submit"]');
  const formData = new FormData(form);

  if (submitButton) submitButton.disabled = true;

  try {
    const response = await fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: { Accept: 'text/html' },
    });

    console.log('[newsletter-form] response status', response.status, response.url);

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const freshWrap = doc.querySelector('[data-newsletter-form-wrap]');

    console.log('[newsletter-form] freshWrap found?', !!freshWrap);

    if (freshWrap && wrap) {
      wrap.replaceWith(freshWrap);
      // Re-focus the email field so screen reader users land on the result.
      const successOrErrors = freshWrap.querySelector('.newsletter__success, .newsletter__errors');
      if (successOrErrors) successOrErrors.setAttribute('tabindex', '-1');
      if (successOrErrors) successOrErrors.focus();
    } else {
      console.warn('[newsletter-form] could not find [data-newsletter-form-wrap] in the response — falling back to a normal submit.');
      form.submit();
    }
  } catch (error) {
    console.error('[newsletter-form] submit error', error);
    if (submitButton) submitButton.disabled = false;
  }
});
